import { PagePending } from "@/components/ui/PagePending";
import { getAllAccountsQuery } from "@/api/accountOwnership";
import { queryClient } from "@/api/utils";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { fallback, number, object, optional, picklist, pipe, string, toMinValue } from "valibot";

export const Route = createFileRoute("/admin/account-owners")({
  pendingComponent: PagePending,
  component: lazyRouteComponent(() => import("./+AccountOwnersPage")),
  validateSearch: object({
    page: fallback(pipe(optional(number(), 1), toMinValue(1)), 1),
    "page-size": fallback(pipe(optional(number(), 100), toMinValue(10)), 100),
    type: fallback(optional(picklist(["supplier", "supporter"])), undefined),
    ownerId: fallback(optional(string()), undefined),
    country: fallback(optional(picklist(["NZ", "AU", "US", "CA", "GB", "IE"])), undefined),
    q: optional(string()),
  }),
  beforeLoad: ctx => ({
    breadcrumb: "Account Owners",
    page: ctx.search.page,
    pageSize: ctx.search["page-size"],
  }),
  loader: ({ context }) => {
    queryClient.prefetchQuery(getAllAccountsQuery({ page: context.page, pageSize: context.pageSize }));
  },
  head: () => ({ meta: seo({ title: "Account Owners" }) }),
});
